<template>
  <div class="thank-you-container">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-8-desktop is-10-tablet">
          <div class="card">
            <header class="card-header">
              <div class="card-header-title is-block has-text-centered">
                <div class="icon-wrapper success">
                  <b-icon
                    icon="check-circle"
                    size="is-large"
                    type="is-success"
                    custom-size="mdi-48px"
                  />
                </div>
                <h1
                  class="title is-spaced is-size-2-desktop is-size-4-mobile has-text-weight-bold mt-4 mb-2"
                >
                  ¡Encuesta Completada!
                </h1>
                <p
                  class="subtitle is-size-5-desktop is-size-6-mobile has-text-grey"
                >
                  Gracias por tu tiempo y participación
                </p>
              </div>
            </header>

            <div class="card-content">
              <div class="content has-text-centered">
                <p class="has-text-grey-dark mb-5" style="line-height: 1.6;">
                  Tus respuestas han sido guardadas exitosamente. La información
                  que has proporcionado es muy valiosa.
                  <br /><br />
                  Esperamos que tengas un bonito día.
                </p>

                <div class="contact-note">
                  <p class="is-size-7 has-text-grey">
                    Si tienes alguna pregunta o comentario adicional, no dudes
                    en contactarnos.
                  </p>
                </div>
              </div>
            </div>

            <footer class="card-footer">
              <div class="card-footer-item">
                <b-button
                  type="is-primary"
                  size="is-medium"
                  expanded
                  icon-left="home"
                  @click="goToHome"
                >
                  Volver al Inicio
                </b-button>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThankYou",
  methods: {
    goToHome() {
      window.location.href = "/";
    },
  },
};
</script>

<style scoped>
.thank-you-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  background-color: #f5f5f5;
}

.card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-header-title {
  padding: 2rem 1.5rem;
}

.icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
}

.icon-wrapper.success {
  background-color: rgba(72, 199, 142, 0.15);
}

.card-content {
  padding: 1.5rem;
}

.contact-note {
  padding-top: 1rem;
}

.card-footer-item {
  padding: 1.5rem;
  display: block;
}

/* Responsive adjustments */
@media screen and (max-width: 768px) {
  .thank-you-container {
    padding: 1rem;
  }

  .card-header-title {
    padding: 1.5rem 1rem;
  }

  .icon-wrapper {
    width: 4rem;
    height: 4rem;
  }

  .info-box {
    padding: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/sections/survey/ThankYou.vue